import SEO from '@/components/common/SEO';
import LoadingScreen from '@/components/ui/loading-screen';
import { useAuth } from '@/contexts/AuthContext';
import { useProfile } from '@/hooks/useProfile';
import { Navigate, useSearchParams } from 'react-router-dom';

export default function SupportOpen() {
  const { loading: authLoading, user } = useAuth();
  const { profile } = useProfile();
  const [searchParams] = useSearchParams();
  const conversation = searchParams.get('conversation')?.trim().toUpperCase();
  const inboxPath = conversation ? `/support/inbox?conversation=${encodeURIComponent(conversation)}` : '/support/inbox';

  if (authLoading || (user && !profile)) {
    return (
      <>
        <SEO
          title="Open Support Inbox"
          description="Secure admin link for a CanXP support conversation."
          url="/support/open"
          robots="noindex,nofollow,noarchive,noimageindex"
          suppressImagePreview
        />
        <LoadingScreen />
      </>
    );
  }

  if (!user) {
    return (
      <>
        <SEO
          title="Open Support Inbox"
          description="Secure admin link for a CanXP support conversation."
          url="/support/open"
          robots="noindex,nofollow,noarchive,noimageindex"
          suppressImagePreview
        />
        <Navigate to="/auth" replace state={{ returnUrl: inboxPath }} />
      </>
    );
  }

  return (
    <>
      <SEO
        title="Open Support Inbox"
        description="Secure admin link for a CanXP support conversation."
        url="/support/open"
        robots="noindex,nofollow,noarchive,noimageindex"
        suppressImagePreview
      />
      <Navigate to={inboxPath} replace />
    </>
  );
}
